import { Helmet } from "react-helmet"
import Header from "../components/Header"
import SideNav from "../components/SideNav"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import Loader from "../components/Loader"
import {
  sendBulkPushNotification,
  resetPushNotification
} from "../actions/pushNotificationActions"

const PushNotificationScreen = () => {
  const dispatch = useDispatch()

  const [header, setHeader] = useState("")
  const [body, setBody] = useState("")
  const [showConfirm, setShowConfirm] = useState(false)

  const sendPushNotification = useSelector((state) => state.sendPushNotification)
  const { loading, success, error, data } = sendPushNotification || {}

  useEffect(() => {
    if (success) {
      setHeader("")
      setBody("")
      setShowConfirm(false)
    }
  }, [success])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!header.trim() || !body.trim()) return
    setShowConfirm(true)
  }

  const handleConfirm = () => {
    dispatch(sendBulkPushNotification({ header, body }))
  }

  const handleReset = () => {
    dispatch(resetPushNotification())
    setShowConfirm(false)
  }

  return (
    <>
      <SideNav />
      <Helmet>
        <title>Admin | PennyTree - Push Notifications</title>
      </Helmet>
      <section className="page-container">
        <div className="page-content">
          <Header />
          <div className="page-body">
            <h1>Push Notifications</h1>

            <div style={{ maxWidth: "600px" }}>
              {/* Info Banner */}
              <div style={{
                background: "#1a1a1a",
                border: "1px solid #4cc800",
                borderRadius: "8px",
                padding: "14px 18px",
                marginBottom: "24px",
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              }}>
                <span style={{ color: "#4cc800", fontSize: "18px", lineHeight: 1 }}>ℹ</span>
                <p style={{ margin: 0, fontSize: "13px", color: "#d2d2d2", lineHeight: 1.6 }}>
                  This will send a bulk push notification to <strong style={{ color: "#fff" }}>all PennyTree app users</strong>. Please review your message carefully before sending.
                </p>
              </div>

              {/* Success Message */}
              {success && (
                <div style={{
                  background: "#0d2b0d",
                  border: "1px solid #4cc800",
                  borderRadius: "8px",
                  padding: "14px 18px",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ color: "#4cc800", fontSize: "18px" }}>✓</span>
                    <p style={{ margin: 0, color: "#4cc800", fontSize: "14px" }}>
                      {data?.message || "Bulk push notification sent successfully"}
                    </p>
                  </div>
                  <button
                    onClick={handleReset}
                    style={{ background: "transparent", border: "none", color: "#aaa", cursor: "pointer", fontSize: "18px" }}
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* Error Message */}
              {error && (
                <div style={{
                  background: "#2b0d0d",
                  border: "1px solid #dc3545",
                  borderRadius: "8px",
                  padding: "14px 18px",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ color: "#dc3545", fontSize: "18px" }}>✕</span>
                    <p style={{ margin: 0, color: "#dc3545", fontSize: "14px" }}>{error}</p>
                  </div>
                  <button
                    onClick={handleReset}
                    style={{ background: "transparent", border: "none", color: "#aaa", cursor: "pointer", fontSize: "18px" }}
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* Form */}
              <div style={{
                background: "#1a1a1a",
                borderRadius: "10px",
                padding: "28px"
              }}>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label style={{ fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase", color: "#d2d2d2" }}>
                      Notification Header
                    </label>
                    <input
                      className="invest-input"
                      type="text"
                      value={header}
                      onChange={(e) => setHeader(e.target.value)}
                      placeholder="Enter notification title..."
                      maxLength={100}
                      style={{ width: "100%" }}
                      required
                    />
                    <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#666", textAlign: "right" }}>
                      {header.length}/100
                    </p>
                  </div>

                  <div className="form-group">
                    <label style={{ fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase", color: "#d2d2d2" }}>
                      Notification Body
                    </label>
                    <textarea
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                      placeholder="Enter notification message..."
                      maxLength={500}
                      rows={5}
                      required
                      style={{
                        width: "100%",
                        background: "#1a1a1a",
                        border: "none",
                        color: "#fff",
                        borderRadius: "5px",
                        padding: "16px",
                        fontSize: "14px",
                        resize: "vertical",
                        outline: "none",
                        fontFamily: "inherit",
                        boxSizing: "border-box"
                      }}
                    />
                    <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#666", textAlign: "right" }}>
                      {body.length}/500
                    </p>
                  </div>

                  {loading ? (
                    <Loader />
                  ) : (
                    <button
                      type="submit"
                      className="login-btn"
                      disabled={!header.trim() || !body.trim()}
                      style={{ opacity: (!header.trim() || !body.trim()) ? 0.5 : 1 }}
                    >
                      Send Push Notification
                    </button>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Confirm Modal */}
      {showConfirm && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.7)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px"
        }}>
          <div style={{
            background: "#1a1a1a",
            borderRadius: "12px",
            padding: "28px",
            width: "100%",
            maxWidth: "460px",
            border: "1px solid #333"
          }}>
            <h3 style={{ margin: "0 0 8px", fontSize: "18px", color: "#fff" }}>Confirm Send</h3>
            <p style={{ margin: "0 0 20px", fontSize: "13px", color: "#aaa" }}>
              You are about to send a push notification to <strong style={{ color: "#fff" }}>all users</strong>. This action cannot be undone.
            </p>

            {/* Preview */}
            <div style={{
              background: "#2a2a2a",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px",
              borderLeft: "3px solid #4cc800"
            }}>
              <p style={{ margin: "0 0 6px", fontSize: "13px", fontWeight: "700", color: "#fff" }}>{header}</p>
              <p style={{ margin: 0, fontSize: "13px", color: "#aaa", lineHeight: 1.5 }}>{body}</p>
            </div>

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "transparent",
                  border: "1px solid #444",
                  borderRadius: "6px",
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: "14px"
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={loading}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#4cc800",
                  border: "none",
                  borderRadius: "6px",
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600"
                }}
              >
                {loading ? "Sending..." : "Yes, Send"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PushNotificationScreen